/**
 * Created by intellicar-rinas on 9/10/17.
 */
import React, { Component } from "react";
import "./InTable.css";
import Dom from "../../../../helpers/Dom";
import moment from "moment";
import CallbackBuddy from "../../../../components/CallbackBuddy/CallbackBuddy";
import ReportAPIs from "../../../../APIs/ReportAPIs";
import { processData as tripProcessData } from "../../../../Layouts/config/reports/tripReport";
import { processData as dailyProcessData } from "../../../../Layouts/config/reports/dailyReport";
import { processData as CANdailyProcessData } from "../../../../Layouts/config/reports/canDailyReport";
import { processData as exideBatteryProcessData } from "../../../../Layouts/config/reports/exideBatteryReport";
import { processData as rangeProcessData } from "../../../../Layouts/config/reports/rangeReport";
import { processData as batteryProcessData } from "../../../../Layouts/config/reports/clnBatteryReport";
import { processData as subscriptionProcessData } from "../../../../Layouts/config/reports/clnSubscriptionReport";
import { processData as summaryProcessData } from "../../../../Layouts/config/reports/summaryReport";
import { processData as newTripProcessData } from "../../../../Layouts/config/reports/tripReport2";
import { filterAndSetData1, processData as mileageProcessData } from "../../../../Layouts/config/reports/mileageReport"
import momentTZ from "moment-timezone";
import { dateFormat } from "../../../../constants/constants";
import { tickStep } from "d3";
// import {setDate} from '../InDatePicker/InDatePicker'
import { filterAndSetData } from "../../../../Layouts/config/reports/tripReport";

class InTable extends Component {
  state = {
    head: [],
    body: [],
    filtered: [],
    index: 0,
    limit: 200,
    clickedItems: [],
    tripClickedItems: [],
    mileageClickedItems: [],
    newTripClickedItem: [],
    dailyClickedItems: [],
    canDailyClickedItems: [],
    exideBatteryClickedItems: [],
    rangeClickedItems: [],
    rangeLastClicked: [],
    summaryClickedItems: [],
    subscriptionClickedItems: [],
    pageCount: null,
    tripVehicles: null,
    mileageVehicles: null,
    newTripVehicles: null,
    dailyVehicles: null,
    canDailyVehicles: null,
    exideBatteryVehicles: null,
    rangeVehicles: null,
    summaryVehicles: null,
    batteryVehicles: null,
    tripLastClicked: 0,
    mileageLastClicked: 0,
    newTripLastClicked: 0,
    dailyLastClicked: 0,
    canDailyLastClicked: 0,
    exideBatteryLastClicked: 0,
    summaryLastClicked: 0,
    batteryLastClicked: 0,
    datePopup: false,
    lastTripDate: { starttime: null, endtime: null },
    lastMileageDate:{ starttime: null, endtime: null},
    lastNewTripDate: { starttime: null, endtime: null },
    lastDailyDate: { starttime: null, endtime: null },
    lastSummaryDate: { starttime: null, endtime: null },
    lastCanDailyDate: { starttime: null, endtime: null },
    lastExideBatteryDate: { starttime: null, endtime: null },
    lastRangeDate: { starttime: null, endtime: null },
    lastBatteryDate: { starttime: null, endtime: null },
    startDate: null,
    endDate: null,
    alarmPages: 0,
    gpsPages: 0,
    chargePages: 0,
    peakPages: 0,
    hourlyPages: 0,
    locFrom: false,
    locTo: false,
    items: [],
    hasMore: true,
    startIndex: 50,
  };

  constructor() {
    super();

    this.uid = "in_table_" + Math.random();

    [
      "setData",
      "getMaxHeight",
      "getBody",
      "getPagination",
      "changePage",
      "setBusy",
      "toggleSort",
      "saveState",
      "searchInputChanged",
      "getSortIcon",
      "processData",
      "getHead",
      "resume",
      "onDataChange",
      "getBodyData",
      "searchClicked",
    ].map((item) => (this[item] = this[item].bind(this)));

    this.onVehicleChange = () => {
      if (!this.mounted) return;
      this.vehicle = window.selectedVehicles;
      this.forceUpdate();
    };

    window.addOnSaveVehicleStateListener(this.uid, this.onVehicleChange);
    this.reportData = {};
    this.clickedItem = [0];
    this.newTripClickedItem = [0];
    this.dailyClickedItem = [0];
    this.canDailyClickedItem = [0];
    this.exideBatteryClickedItem = [0];
    this.rangeClickedItem = [0];
    this.summaryClickedItem = [0];
    this.mileageClickedItem= [0]; 
    this.batteryClickedItem = [0];
    this.subscriptionClickedItem = [0];
    this.reportKeysData = [
      "new_trip_report",
      "trip_report",
      "daily_report",
      "summary_report",
      "can_daily_report",
      "exide_battery_report",
      "range_report",
      "mileage_report",
      "battery_trip_report",
      "subscription_report"
    ];
    this.tripData = {};
    this.mileageData={}
    this.tripDataNew = {};
    this.dailyData = {};
    this.canDailyData = [];
    this.exideBatteryData = {};
    this.rangeData = [];
    this.batteryData = [];
    this.subscriptionData = [];
    this.summaryData = {};
    this.sortedReport = [];

    this.handleScroll = this.handleScroll.bind(this);
    window.resetIndex = () => {
      this.setState({ startIndex: 50, items: [] });
    };
  }

  debounce(func, wait) {
    let timeout;
    return (...args) => {
      clearTimeout(timeout);
      timeout = setTimeout(() => func.apply(this, args), wait);
    };
  }

  componentDidMount() {
    this.scrollRef.addEventListener(
      "scroll",
      this.debounce(this.handleScroll, 100)
    );
    this.evOnly = window.userInfo.SELF.EV_ONLY;
    this.evConfig = window.userInfo.SELF.enable_EV_trip_report;
    this.mounted = true;
    this.vehicle = window.selectedVehicles;
    this.pblReport = window.userInfo.SELF.pbl_report;
    if (this.props.data && this.props.data.head) {
      this.setState({
        head: this.props.data.head,
      });
    }
    window.totalPage = 1;
  window.currentPage = 1;
    this.resume();
  }

  componentWillReceiveProps(props) {
    this.vehicle = window.selectedVehicles;
    this.dataProps = props;
    if (window.getButtonClicked && !this.state.datePopup) {
      window.getButtonClicked = false;
    }
    if (window.getButtonClicked && this.state.datePopup) {
      // console.log("inside if true")
      window.getButtonClicked = false;
      this.setState({ datePopup: false });
    }

    if (props && props.selectedVehicleId && props.selectedVehicleId.showPage) {
      if (this.props.schemaKey === "trip_report") {
        this.tripData = [];
        this.tripClickedItem = [0];
        this.setState({ tripClickedItems: [], tripLastClicked: 0, index: 0 });

        const count = props.selectedVehicleId.tripPageno || 0;
        window.totalPage = count;
        window.currentPage = this.state.index + 1; 
      }
      if (this.props.schemaKey === "mileage_report") {
        this.mileageData = [];
        this.mileageClickedItem = [0];
        this.setState({ mileageClickedItems: [], mileageLastClicked: 0, index: 0 });
      }
      
      if (this.props.schemaKey === "new_trip_report") {
        this.tripDataNew = {};
        this.newTripClickedItem = [0];
        this.setState({
          newTripClickedItem: [],
          newTripLastClicked: 0,
          index: 0,
        });
      }
      if (this.props.schemaKey === "daily_report") {
        this.dailyData = [];
        this.dailyClickedItem = [0];
        this.setState({ dailyClickedItems: [], dailyLastClicked: 0, index: 0 });
      }
      if (this.props.schemaKey === "can_daily_report") {
        this.canDailyData = [];
        this.canDailyClickedItem = [0];
        this.setState({
          canDailyClickedItems: [],
          canDailyLastClicked: 0,
          index: 0,
        });
      }
      if (this.props.schemaKey === "exide_battery_report") {
        this.exideBatteryData = {};
        this.exideBatteryClickedItem = [0];
        this.setState({
          exideBatteryClickedItems: [],
          exideBatteryLastClicked: 0,
          index: 0,
        });
      }
      if (this.props.schemaKey === "range_report") {
        this.rangeData = [];
        this.rangeClickedItem = [0];
        this.setState({ rangeClickedItems: [], rangeLastClicked: 0, index: 0 });
      }
      if (this.props.schemaKey === "battery_trip_report") {
        this.batteryData = [];
        this.batteryClickedItem = [0];
        this.setState({ batteryClickedItems: [], batteryLastClicked: 0, index: 0 });
      }
      if (this.props.schemaKey === "subscription_report") {
        this.subscriptionData = [];
        this.subscriptionClickedItem = [0];
        this.setState({ subscriptionClickedItems: [0], index: 0 });
      }
      if (this.props.schemaKey === "summary_report") {
        this.summaryData = [];
        this.summaryClickedItem = [0];
        this.setState({
          summaryClickedItems: [],
          summaryLastClicked: 0,
          index: 0,
        });
      }
      props.selectedVehicleId.showPage = false;
    }

    if (props && props.selectedVehicleId) {
      if (props.schemaKey === "trip_report") {
        if (
          props.selectedVehicleId &&
          props.selectedVehicleId.reportName === props.schemaKey &&
          props.selectedVehicleId.starttime &&
          props.selectedVehicleId.endtime
        ) {
          if (
            props.selectedVehicleId.starttime !==
              this.state.lastTripDate.starttime ||
            props.selectedVehicleId.endtime !== this.state.lastTripDate.endtime
          ) {
            this.setState({
              lastTripDate: {
                starttime: props.selectedVehicleId.starttime,
                endtime: props.selectedVehicleId.endtime,
              },
            });
          }
        }
      }
        if (props.schemaKey === "mileage_report") {    
          if (
            props.selectedVehicleId &&
            props.selectedVehicleId.reportName === props.schemaKey &&
            props.selectedVehicleId.starttime &&
            props.selectedVehicleId.endtime
          ) {
            if (
              props.selectedVehicleId.starttime !==
                this.state.lastMileageDate.starttime ||
              props.selectedVehicleId.endtime !== this.state.lastMileageDate.endtime
            ) {
              this.setState({
                lastMileageDate: {
                  starttime: props.selectedVehicleId.starttime,
                  endtime: props.selectedVehicleId.endtime,
                },
              });
            }
          }
        }
      if (props.schemaKey === "new_trip_report") {
        if (
          props.selectedVehicleId &&
          props.selectedVehicleId.reportName === props.schemaKey &&
          props.selectedVehicleId.starttime &&
          props.selectedVehicleId.endtime
        ) {
          if (
            props.selectedVehicleId.starttime !==
              this.state.lastNewTripDate.starttime ||
            props.selectedVehicleId.endtime !==
              this.state.lastNewTripDate.endtime
          ) {
            this.setState({
              lastNewTripDate: {
                starttime: props.selectedVehicleId.starttime,
                endtime: props.selectedVehicleId.endtime,
              },
            });
          }
        }
      }
      if (props.schemaKey === "daily_report") {
        if (
          props.selectedVehicleId &&
          props.selectedVehicleId.reportName === props.schemaKey &&
          props.selectedVehicleId.starttime &&
          props.selectedVehicleId.endtime
        ) {
          if (
            props.selectedVehicleId.starttime !==
              this.state.lastDailyDate.starttime ||
            props.selectedVehicleId.endtime !== this.state.lastDailyDate.endtime
          ) {
            this.setState({
              lastDailyDate: {
                starttime: props.selectedVehicleId.starttime,
                endtime: props.selectedVehicleId.endtime,
              },
            });
          }
        }
      }
      if (props.schemaKey === "can_daily_report") {
        if (
          props.selectedVehicleId &&
          props.selectedVehicleId.reportName === props.schemaKey &&
          props.selectedVehicleId.starttime &&
          props.selectedVehicleId.endtime
        ) {
          if (
            props.selectedVehicleId.starttime !==
              this.state.lastCanDailyDate.starttime ||
            props.selectedVehicleId.endtime !==
              this.state.lastCanDailyDate.endtime
          ) {
            this.setState({
              lastCanDailyDate: {
                starttime: props.selectedVehicleId.starttime,
                endtime: props.selectedVehicleId.endtime,
              },
            });
          }
        }
      }
      if (props.schemaKey === "exide_battery_report") {
        if (
          props.selectedVehicleId &&
          props.selectedVehicleId.reportName === props.schemaKey &&
          props.selectedVehicleId.starttime &&
          props.selectedVehicleId.endtime
        ) {
          if (
            props.selectedVehicleId.starttime !==
              this.state.lastExideBatteryDate.starttime ||
            props.selectedVehicleId.endtime !==
              this.state.lastExideBatteryDate.endtime
          ) {
            this.setState({
              lastExideBatteryDate: {
                starttime: props.selectedVehicleId.starttime,
                endtime: props.selectedVehicleId.endtime,
              },
            });
          }
        }
      }
      if (props.schemaKey === "range_report") {
        if (
          props.selectedVehicleId &&
          props.selectedVehicleId.reportName === props.schemaKey &&
          props.selectedVehicleId.starttime &&
          props.selectedVehicleId.endtime
        ) {
          if (
            props.selectedVehicleId.starttime !==
              this.state.lastRangeDate.starttime ||
            props.selectedVehicleId.endtime !== this.state.lastRangeDate.endtime
          ) {
            this.setState({
              lastRangeDate: {
                starttime: props.selectedVehicleId.starttime,
                endtime: props.selectedVehicleId.endtime,
              },
            });
          }
        }
      }
      if (props.schemaKey === "summary_report") {
        if (
          props.selectedVehicleId &&
          props.selectedVehicleId.reportName === props.schemaKey &&
          props.selectedVehicleId.starttime &&
          props.selectedVehicleId.endtime
        ) {
          if (
            props.selectedVehicleId.starttime !==
              this.state.lastSummaryDate.starttime ||
            props.selectedVehicleId.endtime !==
              this.state.lastSummaryDate.endtime
          ) {
            this.setState({
              lastSummaryDate: {
                starttime: props.selectedVehicleId.starttime,
                endtime: props.selectedVehicleId.endtime,
              },
            });
          }
        }
      }
      if (props.schemaKey === "battery_trip_report") {
        if (
          props.selectedVehicleId &&
          props.selectedVehicleId.reportName === props.schemaKey &&
          props.selectedVehicleId.starttime &&
          props.selectedVehicleId.endtime
        ) {
          if (
            props.selectedVehicleId.starttime !==
              this.state.lastBatteryDate.starttime ||
            props.selectedVehicleId.endtime !== this.state.lastBatteryDate.endtime
          ) {
            this.setState({
              lastBatteryDate: {
                starttime: props.selectedVehicleId.starttime,
                endtime: props.selectedVehicleId.endtime,
              },
            });
          }
        }
      }

      if (this.props.schemaKey === "trip_report") {
        if (
          props.selectedVehicleId.tripFirstData &&
          this.tripData[1] !== props.selectedVehicleId.tripFirstData
        ) {
          this.tripData[1] = props.selectedVehicleId.tripFirstData;
          this.setState({ currentPage: props.selectedVehicleId.tripFirstData });
        }
      }
      if (this.props.schemaKey === "mileage_report") {
        if (
          props.selectedVehicleId.mileageFirstData &&
          this.mileageData[1] !== props.selectedVehicleId.mileageFirstData
        ) {
          this.mileageData[1] = props.selectedVehicleId.mileageFirstData;
          this.setState({ currentPage: props.selectedVehicleId.mileageFirstData });
        }
      }
      if (this.props.schemaKey === "new_trip_report") {
        if (
          props.selectedVehicleId.tripFirstDataNew &&
          this.tripDataNew[1] !== props.selectedVehicleId.tripFirstDataNew
        ) {
          this.tripDataNew[1] = props.selectedVehicleId.tripFirstDataNew;
          this.setState({
            currentPage: props.selectedVehicleId.tripFirstDataNew,
          });
        }
      }
      if (
        this.props.schemaKey === "daily_report" &&
        props.selectedVehicleId.dailyFirstData &&
        this.dailyData[1] !== props.selectedVehicleId.dailyFirstData
      ) {
        this.dailyData[1] = props.selectedVehicleId.dailyFirstData;
        this.setState({ currentPage: props.selectedVehicleId.dailyFirstData });
      }
      if (
        this.props.schemaKey === "can_daily_report" &&
        props.selectedVehicleId.canDailyFirstData &&
        this.canDailyData[1] !== props.selectedVehicleId.canDailyFirstData
      ) {
        this.canDailyData[1] = props.selectedVehicleId.canDailyFirstData;
        this.setState({
          currentPage: props.selectedVehicleId.canDailyFirstData,
        });
      }
      if (
        this.props.schemaKey === "exide_battery_report" &&
        props.selectedVehicleId.exideBatteryFirstData &&
        this.exideBatteryData[1] !== props.selectedVehicleId.exideBatteryFirstData
      ) {
        this.exideBatteryData[1] = props.selectedVehicleId.exideBatteryFirstData;
        this.setState({
          currentPage: props.selectedVehicleId.exideBatteryFirstData,
        });
      }
      if (
        this.props.schemaKey === "range_report" &&
        props.selectedVehicleId.rangeFirstData &&
        this.rangeData[1] !== props.selectedVehicleId.rangeFirstData
      ) {
        this.rangeData[1] = props.selectedVehicleId.rangeFirstData;
        this.setState({ currentPage: props.selectedVehicleId.rangeFirstData });
      }
      if (
        this.props.schemaKey === "battery_trip_report" &&
        props.selectedVehicleId.BatteryFirstData &&
        this.batteryData[1] !== props.selectedVehicleId.BatteryFirstData
      ) {
        this.batteryData[1] = props.selectedVehicleId.BatteryFirstData;
        this.setState({ currentPage: props.selectedVehicleId.BatteryFirstData });
      }
      if (
        this.props.schemaKey === "subscription_report" &&
        props.selectedVehicleId.subscriptionFirstData &&
        this.subscriptionData[1] !==
          props.selectedVehicleId.subscriptionFirstData
      ) {
        this.subscriptionData[1] =
          props.selectedVehicleId.subscriptionFirstData;
        this.setState({
          currentPage: props.selectedVehicleId.subscriptionFirstData,
        });
      }
      if (
        this.props.schemaKey === "summary_report" &&
        props.selectedVehicleId.summaryFirstData &&
        this.summaryData[1] !== props.selectedVehicleId.summaryFirstData
      ) {
        this.summaryData[1] = props.selectedVehicleId.summaryFirstData;
        this.setState({
          currentPage: props.selectedVehicleId.summaryFirstData,
        });
      }
    } else {
      this.setState({ currentPage: [] });
    }
    if (this.props.schemaKey === "trip_report") {
      this.setState({ index: this.state.tripLastClicked });
    }
    if (this.props.schemaKey === "mileage_report") {
      this.setState({ index: this.state.mileageLastClicked });
    }
    if (this.props.schemaKey === "new_trip_report") {
      this.setState({ index: this.state.newTripLastClicked });
    } else if (this.props.schemaKey === "daily_report") {
      this.setState({ index: this.state.dailyLastClicked });
    } else if (this.props.schemaKey === "can_daily_report") {
      this.setState({ index: this.state.canDailyLastClicked });
    } else if (this.props.schemaKey === "exide_battery_report") {
      this.setState({ index: this.state.exideBatteryLastClicked });
    } else if (this.props.schemaKey === "range_report") {
      this.setState({ index: this.state.rangeLastClicked });
    } else if (this.props.schemaKey === "summary_report") {
      this.setState({ index: this.state.summaryLastClicked });
    } else if(this.props.schemaKey === "battery_trip_report"){
      this.setState({ index: this.state.batteryLastClicked });
    }
    if (this.props.schemaKey != props.schemaKey) {
      this.refs.search.value = "";
      this.sortedReport = [];
      this.reportData = [];
      setTimeout(() => {
        this.setState({ datePopup: false });
      });    
      setTimeout(() => {
        if (
          props.schemaKey === "trip_report" &&
          this.state.lastTripDate.starttime &&
          this.state.lastTripDate.endtime
        ) {
          if (
            window.currentValue.starttime !==
              this.state.lastTripDate.starttime ||
            window.currentValue.endtime !== this.state.lastTripDate.endtime
          ) {
            setTimeout(() => {
              this.setState({
                datePopup: true,
                startDate: moment(this.state.lastTripDate.starttime).format(
                  dateFormat
                ),
                endDate: moment(this.state.lastTripDate.endtime).format(
                  dateFormat
                ),
              });
            });
          }
        }
        if (
          props.schemaKey === "mileage_report" &&
          this.state.lastMileageDate.starttime &&
          this.state.lastMileageDate.endtime
        ) {
          
          if (
            window.currentValue.starttime !==
              this.state.lastMileageDate.starttime ||
            window.currentValue.endtime !== this.state.lastMileageDate.endtime
          ) {
            setTimeout(() => {
              this.setState({
                datePopup: true,
                startDate: moment(this.state.lastMileageDate.starttime).format(
                  dateFormat
                ),
                endDate: moment(this.state.lastMileageDate.endtime).format(
                  dateFormat
                ),
              });
            });
          }
        }
        if (
          props.schemaKey === "new_trip_report" &&
          this.state.lastNewTripDate.starttime &&
          this.state.lastNewTripDate.endtime
        ) {
          if (
            window.currentValue.starttime !==
              this.state.lastNewTripDate.starttime ||
            window.currentValue.endtime !== this.state.lastNewTripDate.endtime
          ) {
            setTimeout(() => {
              this.setState({
                datePopup: true,
                startDate: moment(this.state.lastNewTripDate.starttime).format(
                  dateFormat
                ),
                endDate: moment(this.state.lastNewTripDate.endtime).format(
                  dateFormat
                ),
              });
            });
          }
        }
        if (
          props.schemaKey === "daily_report" &&
          this.state.lastDailyDate.starttime &&
          this.state.lastDailyDate.endtime
        ) {
          if (
            window.currentValue.starttime !==
              this.state.lastDailyDate.starttime ||
            window.currentValue.endtime !== this.state.lastDailyDate.endtime
          ) {
            setTimeout(() => {
              this.setState({
                datePopup: true,
                startDate: moment(this.state.lastDailyDate.starttime).format(
                  dateFormat
                ),
                endDate: moment(this.state.lastDailyDate.endtime).format(
                  dateFormat
                ),
              });
            });
          }
        }
        if (
          props.schemaKey === "can_daily_report" &&
          this.state.lastCanDailyDate.starttime &&
          this.state.lastCanDailyDate.endtime
        ) {
          if (
            window.currentValue.starttime !==
              this.state.lastCanDailyDate.starttime ||
            window.currentValue.endtime !== this.state.lastCanDailyDate.endtime
          ) {
            setTimeout(() => {
              this.setState({
                datePopup: true,
                startDate: moment(this.state.lastCanDailyDate.starttime).format(
                  dateFormat
                ),
                endDate: moment(this.state.lastCanDailyDate.endtime).format(
                  dateFormat
                ),
              });
            });
          }
        }
        if (
          props.schemaKey === "exide_battery_report" &&
          this.state.lastExideBatteryDate.starttime &&
          this.state.lastExideBatteryDate.endtime
        ) {
          if (
            window.currentValue.starttime !==
              this.state.lastExideBatteryDate.starttime ||
            window.currentValue.endtime !== this.state.lastExideBatteryDate.endtime
          ) {
            setTimeout(() => {
              this.setState({
                datePopup: true,
                startDate: moment(this.state.lastExideBatteryDate.starttime).format(
                  dateFormat
                ),
                endDate: moment(this.state.lastExideBatteryDate.endtime).format(
                  dateFormat
                ),
              });
            });
          }
        }
        if (
          props.schemaKey === "range_report" &&
          this.state.lastRangeDate.starttime &&
          this.state.lastRangeDate.endtime
        ) {
          if (
            window.currentValue.starttime !==
              this.state.lastRangeDate.starttime ||
            window.currentValue.endtime !== this.state.lastRangeDate.endtime
          ) {
            setTimeout(() => {
              this.setState({
                datePopup: true,
                startDate: moment(this.state.lastRangeDate.starttime).format(
                  dateFormat
                ),
                endDate: moment(this.state.lastRangeDate.endtime).format(
                  dateFormat
                ),
              });
            });
          }
        }
        if (
          props.schemaKey === "battery_trip_report" &&
          this.state.lastBatteryDate.starttime &&
          this.state.lastBatteryDate.endtime
        ) {
          if (
            window.currentValue.starttime !==
              this.state.lastBatteryDate.starttime ||
            window.currentValue.endtime !== this.state.lastBatteryDate.endtime
          ) {
            setTimeout(() => {
              this.setState({
                datePopup: true,
                startDate: moment(this.state.lastBatteryDate.starttime).format(
                  dateFormat
                ),
                endDate: moment(this.state.lastBatteryDate.endtime).format(
                  dateFormat
                ),
              });
            });
          }
        }
        if (
          props.schemaKey === "summary_report" &&
          this.state.lastSummaryDate.starttime &&
          this.state.lastSummaryDate.endtime
        ) {
          if (
            window.currentValue.starttime !==
              this.state.lastSummaryDate.starttime ||
            window.currentValue.endtime !== this.state.lastSummaryDate.endtime
          ) {
            setTimeout(() => {
              this.setState({
                datePopup: true,
                startDate: moment(this.state.lastSummaryDate.starttime).format(
                  dateFormat
                ),
                endDate: moment(this.state.lastSummaryDate.endtime).format(
                  dateFormat
                ),
              });
            });
          }
        }
      });
      this.data = [];
      this.setState({ clickedItems: [] });
    }
  }

  onDataChange() {
    if (this.schemaKey !== this.props.schemaKey) {
      this.schemaKey = this.props.schemaKey;
      this.resume();
    }
  }

  resume() {
    this.setState({ startIndex: 50, hasMore: true });
    if (!this.mounted) return;
    if (this.props.resume && this.props.resume.state) {
      this.setState({ ...this.props.resume.state }, () => {
        let tempBody = this.state.body;
        if (tempBody.length) {
          tempBody = tempBody.slice(0, 50);
          this.setState({ items: tempBody });
        }
        this.refs.search.value = this.props.resume.state.searchInput
          ? this.props.resume.state.searchInput
          : "";
        // this.searchInputChanged();
      });
    } else {
      this.setState({ body: [], busy: false }, () => {
        if (this.props.schemaKey !== "can_data_report")
          this.refs.search.value = "";
        // this.searchInputChanged();
      });

      this.setState({ body: [], busy: false }, () => {
        if (this.props.schemaKey !== "jem_can_data_report")
          this.refs.search.value = "";
        // this.searchInputChanged();
      });

      this.setState({ body: [], busy: false }, () => {
        if (this.props.schemaKey !== "bg_can_data_report")
          this.refs.search.value = "";
        // this.searchInputChanged();
      });
    }
  }

  processData(data) {
    let head = this.getHead();
    return data.map((item, uid) => {
      item.uid = uid;
      for (let idx in head) {
        switch (head[idx].type) {
          case "DATE":
            item[head[idx].key + "__processed__"] = moment(
              item[head[idx].key]
            ).format(head[idx].format);
            head[idx].processedKey = head[idx].key + "__processed__";
            break;

          default:
            break;
        }
      }
      return item;
    });
  }

  setData(data = [], keepState = false) {    
    if (!this.mounted) return;
    if (this.props.schemaKey === "alarm_report" && data.length) {
      let count = Math.ceil(data.length / this.state.limit);
      this.setState({ alarmPages: count });
    }
    if (this.props.schemaKey === "gps_report" && data.length) {
      let count = Math.ceil(data.length / this.state.limit);
      this.setState({ gpsPages: count });
    }
    if (this.props.schemaKey === "charge_report" && data.length) {
      let count = Math.ceil(data.length / this.state.limit);
      this.setState({ chargePages: count });
    }
    if (this.props.schemaKey === "hourly_report" && data.length) {
      let count = Math.ceil(data.length / this.state.limit);
      this.setState({ hourlyPages: count });
    }
    if (this.props.schemaKey === "peak_hour_report" && data.length) {
      let count = Math.ceil(data.length / this.state.limit);
      this.setState({ peakPages: count });
    }
    let tempData = this.processData(data || []);
    const state = {
      body: this.processData(data || []),
      items: tempData.slice(0, 50),
      // busy:false,
    };
    if (!keepState) {
      let str =
        this.refs.search && this.refs.search.value
          ? this.refs.search.value.trim().toLowerCase()
          : "";
      state.filtered = state.body.filter((item) => {
        for (let idx in item) {
          if ((item[idx] + "").trim().toLowerCase().indexOf(str) !== -1) {
            return true;
          }
        }
        return false;
      });
      if (!this.reportKeysData.includes(this.props.schemaKey)) {
        const prevItems = this.state.limit * this.state.index;
        if (state.body.length < prevItems) {
          state.index = 0;
        }
      }
    }
    this.setState(state, () => {
      this.toggleSort(this.state.sortBy, true);
      setTimeout(() => {
        this.setState({ busy: false });
      }, 200);
    });
  }

  setBusy(status) {
    if (!this.mounted) return;
    this.setState({
      busy: status,
    });
  }

  getBody(body, index, limit) {
    if (
      this.props.schemaKey === "jem_can_data_report" &&
      this.state.filtered.length
    )
      {limit = this.state.filtered.length;}
    if (
      this.props.schemaKey === "can_data_report" &&
      this.state.filtered.length
    )
      limit = this.state.filtered.length;
      if (
        this.props.schemaKey === "bg_can_data_report" &&
        this.state.filtered.length
      )
        limit = this.state.filtered.length;
    // return this.state.busy ? [] : [...body.slice(index*limit, (index+1)*limit)];
    if (this.reportKeysData.includes(this.props.schemaKey)) {
      return this.state.busy ? [] : this.state.items;
    } else {
      return this.state.busy
        ? []
        : body && body.length
        ? [...body.slice(index * limit, (index + 1) * limit)]
        : [];
    }
  }

  getMaxHeight() {
    return this.props.data &&
      this.props.data._position &&
      this.props.data._position.height
      ? this.props.data._position.height - 70
      : 500;
  }

  getBodyData(data) {
    if (typeof data == "object") return "";
    return data;
  }

  getPagination() {
    let pag = [];

    let itemWidth = 40;
    let containerWidth = this.props.data._position.width - 208;
    let itemAllowed = containerWidth / itemWidth;
    // let count = Math.ceil(this.state.filtered.length / this.state.limit);
    let reportKeys = [
      "new_trip_report",
      "trip_report",
      "daily_report",
      "summary_report",
      "can_daily_report",
      "exide_battery_report",
      "range_report",
      "battery_trip_report",
      "subscription_report",
      "mileage_report"];
    let count = null;
    this.splitCount;

    if (this.props.schemaKey === "can_data_report") {
      return pag;
    }
    else if(this.props.schemaKey === "jem_can_data_report") {
      return pag;
    }
    else if(this.props.schemaKey === "bg_can_data_report") {
      return pag;
    }
     else if (
      this.props.selectedVehicleId &&
      reportKeys.includes(this.props.schemaKey)
    ) {
      if (this.props.schemaKey === "trip_report") {
        if (
          this.props.selectedVehicleId.tripVehicles &&
          this.state.tripVehicles !== this.props.selectedVehicleId.tripVehicles
        ) {
          this.setState({
            tripVehicles: this.props.selectedVehicleId.tripVehicles,
          });
        }
        if (
          this.props.selectedVehicleId.tripPageno &&
          this.state.tripPageno !== this.props.selectedVehicleId.tripPageno
        ) {
          this.setState({
            tripPageno: this.props.selectedVehicleId.tripPageno,
          });
        }
        count = this.props.selectedVehicleId.tripPageno
          ? this.props.selectedVehicleId.tripPageno
          : this.state.tripPageno
          ? this.state.tripPageno
          : 0;
      } 
      else if (this.props.schemaKey === "mileage_report") {
        if (
          this.props.selectedVehicleId.mileageVehicles &&
          this.state.mileageVehicles !== this.props.selectedVehicleId.mileageVehicles
        ) {
          this.setState({
            mileageVehicles: this.props.selectedVehicleId.mileageVehicles,
          });
        }
        if (
          this.props.selectedVehicleId.mileagePageno &&
          this.state.mileagePageno !== this.props.selectedVehicleId.mileagePageno
        ) {
          this.setState({
            mileagePageno: this.props.selectedVehicleId.mileagePageno,
          });
        }
        count = this.props.selectedVehicleId.mileagePageno
          ? this.props.selectedVehicleId.mileagePageno
          : this.state.mileagePageno
          ? this.state.mileagePageno
          : 0;
      } 
      else if (this.props.schemaKey === "new_trip_report") {
        if (
          this.props.selectedVehicleId.newTripVehicles &&
          this.state.newTripVehicles !==
            this.props.selectedVehicleId.newTripVehicles
        ) {
          this.setState({
            newTripVehicles: this.props.selectedVehicleId.newTripVehicles,
          });
        }
        if (
          this.props.selectedVehicleId.tripPagenoNew &&
          this.state.tripPagenoNew !==
            this.props.selectedVehicleId.tripPagenoNew
        ) {
          this.setState({
            tripPagenoNew: this.props.selectedVehicleId.tripPagenoNew,
          });
        }
        count = this.props.selectedVehicleId.tripPagenoNew
          ? this.props.selectedVehicleId.tripPagenoNew
          : this.state.tripPagenoNew
          ? this.state.tripPagenoNew
          : 0;
      } else if (this.props.schemaKey === "daily_report") {
        if (
          this.props.selectedVehicleId.dailyVehicles &&
          this.state.dailyVehicles !==
            this.props.selectedVehicleId.dailyVehicles
        ) {
          this.setState({
            dailyVehicles: this.props.selectedVehicleId.dailyVehicles,
          });
        }
        if (
          this.props.selectedVehicleId.dailyPageno &&
          this.state.dailyPageno !== this.props.selectedVehicleId.dailyPageno
        ) {
          this.setState({
            dailyPageno: this.props.selectedVehicleId.dailyPageno,
          });
        }
        count = this.props.selectedVehicleId.dailyPageno
          ? this.props.selectedVehicleId.dailyPageno
          : this.state.dailyPageno
          ? this.state.dailyPageno
          : 0;
      } else if (this.props.schemaKey === "can_daily_report") {
        if (
          this.props.selectedVehicleId.canDailyVehicles &&
          this.state.canDailyVehicles !==
            this.props.selectedVehicleId.canDailyVehicles
        ) {
          this.setState({
            canDailyVehicles: this.props.selectedVehicleId.canDailyVehicles,
          });
        }
        if (
          this.props.selectedVehicleId.canDailyPageno &&
          this.state.canDailyPageno !==
            this.props.selectedVehicleId.canDailyPageno
        ) {
          this.setState({
            canDailyPageno: this.props.selectedVehicleId.canDailyPageno,
          });
        }
        count = this.props.selectedVehicleId.canDailyPageno
          ? this.props.selectedVehicleId.canDailyPageno
          : this.state.canDailyPageno
          ? this.state.canDailyPageno
          : 0;
      } else if (this.props.schemaKey === "exide_battery_report") {
        if (
          this.props.selectedVehicleId.exideBatteryVehicles &&
          this.state.exideBatteryVehicles !==
            this.props.selectedVehicleId.exideBatteryVehicles
        ) {
          this.setState({
            exideBatteryVehicles: this.props.selectedVehicleId.exideBatteryVehicles,
          });
        }
        if (
          this.props.selectedVehicleId.exideBatteryPageno &&
          this.state.exideBatteryPageno !==
            this.props.selectedVehicleId.exideBatteryPageno
        ) {
          this.setState({
            exideBatteryPageno: this.props.selectedVehicleId.exideBatteryPageno,
          });
        }
        count = this.props.selectedVehicleId.exideBatteryPageno
          ? this.props.selectedVehicleId.exideBatteryPageno
          : this.state.exideBatteryPageno
          ? this.state.exideBatteryPageno
          : 0;
      } else if (this.props.schemaKey === "range_report") {
        if (
          this.props.selectedVehicleId.rangeVehicles &&
          this.state.rangeVehicles !==
            this.props.selectedVehicleId.rangeVehicles
        ) {
          this.setState({
            rangeVehicles: this.props.selectedVehicleId.rangeVehicles,
          });
        }
        if (
          this.props.selectedVehicleId.canDailyPageno &&
          this.state.canDailyPageno !==
            this.props.selectedVehicleId.canDailyPageno
        ) {
          this.setState({
            canDailyPageno: this.props.selectedVehicleId.canDailyPageno,
          });
        }
        count = this.props.selectedVehicleId.canDailyPageno
          ? this.props.selectedVehicleId.canDailyPageno
          : this.state.canDailyPageno
          ? this.state.canDailyPageno
          : 0;
      } else if (this.props.schemaKey === "summary_report") {
        if (
          this.props.selectedVehicleId.summaryVehicles &&
          this.state.summaryVehicles !==
            this.props.selectedVehicleId.summaryVehicles
        ) {
          this.setState({
            summaryVehicles: this.props.selectedVehicleId.summaryVehicles,
          });
        }
        if (
          this.props.selectedVehicleId.summaryPageno &&
          this.state.summaryPageno !==
            this.props.selectedVehicleId.summaryPageno
        ) {
          this.setState({
            summaryPageno: this.props.selectedVehicleId.summaryPageno,
          });
        }
        count = this.props.selectedVehicleId.summaryPageno
          ? this.props.selectedVehicleId.summaryPageno
          : this.state.summaryPageno
          ? this.state.summaryPageno
          : 0;
      } else if (this.props.schemaKey === "battery_trip_report") {
        if (
          this.props.selectedVehicleId.batteryVehicles &&
          this.state.batteryVehicles !==
            this.props.selectedVehicleId.batteryVehicles
        ) {
          this.setState({
            batteryVehicles: this.props.selectedVehicleId.batteryVehicles,
          });
        }
        if (
          this.props.selectedVehicleId.batteryPageno &&
          this.state.batteryPageno !==
            this.props.selectedVehicleId.batteryPageno
        ) {
          this.setState({
            batteryPageno: this.props.selectedVehicleId.batteryPageno,
          });
        }
        count = this.props.selectedVehicleId.batteryPageno
          ? this.props.selectedVehicleId.batteryPageno
          : this.state.batteryPageno
          ? this.state.batteryPageno
          : 0;
      } else if (this.props.schemaKey === "subscription_report") {
        count = this.props.selectedVehicleId.subscriptionPageno || 0;
      }else count = 0;
    } else {
      if (
        reportKeys.includes(this.props.schemaKey) &&
        !this.props.selectedVehicleId
      ) {
        count = 0;
      } else if (this.props.schemaKey === "alarm_report") {
        if (this.state && this.state.alarmPages) {
          count = this.state.alarmPages;
        }
      } else if (this.props.schemaKey === "gps_report") {
        if (this.state && this.state.gpsPages) {
          count = this.state.gpsPages;
        }
      } else if (this.props.schemaKey === "charge_report") {
        if (this.state && this.state.chargePages) {
          count = this.state.chargePages;
        }
      } else if (this.props.schemaKey === "hourly_report") {
        if (this.state && this.state.hourlyPages) {
          count = this.state.hourlyPages;
        }
      } else if (this.props.schemaKey === "peak_hour_report") {
        if (this.state && this.state.peakPages) {
          count = this.state.peakPages;
        }
      } else {
        count = Math.ceil(this.state.filtered.length / this.state.limit);
      }
    }
    if (count <= itemAllowed) {
      for (let idx = 0; idx < count; idx++) {
        pag.push(idx);
      }
      return pag;
    }

    let mid = Math.ceil(this.state.index - itemAllowed / 2);
    mid = Math.max(0, Math.min(mid, count - Math.floor(itemAllowed)));

    for (let idx = mid + 1; idx < mid + itemAllowed - 2; idx++) {
      pag.push(idx);
    }

    pag = [0, ...pag, count - 1];
    // console.log("pag",pag)

    return pag;
  }

  changePage(index) {
    if (!this.mounted) return;
    this.setState({
      index: index,
      locFrom: false,
      locTo: false,
      startIndex: 50,
      hasMore: true,
      items: [],
    });
    // if(!this.mounted) return;
    // if(this.state.busy) return
    window.responseError = null;
    let reportKeys = [
      "new_trip_report",
      "trip_report",
      "daily_report",
      "summary_report",
      "can_daily_report",
      "exide_battery_report",
      "range_report",
      "battery_trip_report",
      "subscription_report",
      "mileage_report"
    ];
    if (reportKeys.includes(this.props.schemaKey)) {
      this.setState({ busy: true });

      if (!this.clickedItem.includes(index)) this.clickedItem.push(index);
      // let selectedVehicleIds = this.props.selectedVehicleId.splitedVehicles
      let selectedVehicleIds = null;
      // let selectedVehicleIds = this.state.tripVehicles
      if (this.props.schemaKey === "trip_report") {
        selectedVehicleIds = this.state.tripVehicles;
        if (!this.tripClickedItem.includes(index))
          this.tripClickedItem.push(index);
        this.setState({ tripLastClicked: index });

        // Store pagination info in window object
      let count = this.props.selectedVehicleId.tripPageno
      ? this.props.selectedVehicleId.tripPageno
      : this.state.tripPageno
      ? this.state.tripPageno
      : 0;
    window.totalPage = count;
    window.currentPage = index + 1;
      }
      if (this.props.schemaKey === "mileage_report") {
        selectedVehicleIds = this.state.mileageVehicles;
        if (!this.mileageClickedItem.includes(index))
          this.mileageClickedItem.push(index);
        this.setState({ mileageLastClicked: index });
      }
      if (this.props.schemaKey === "new_trip_report") {
        selectedVehicleIds = this.state.newTripVehicles;
        if (!this.newTripClickedItem.includes(index))
          this.newTripClickedItem.push(index);
        this.setState({ newTripLastClicked: index });
      }
      if (this.props.schemaKey === "daily_report") {
        selectedVehicleIds = this.state.dailyVehicles;
        if (!this.dailyClickedItem.includes(index))
          this.dailyClickedItem.push(index);
        this.setState({ dailyLastClicked: index });
      }
      if (this.props.schemaKey === "can_daily_report") {
        selectedVehicleIds = this.state.canDailyVehicles;
        if (!this.canDailyClickedItem.includes(index))
          this.canDailyClickedItem.push(index);
        this.setState({ canDailyLastClicked: index });
      }
      if (this.props.schemaKey === "exide_battery_report") {
        selectedVehicleIds = this.state.exideBatteryVehicles;
        if (!this.exideBatteryClickedItem.includes(index))
          this.exideBatteryClickedItem.push(index);
        this.setState({ exideBatteryLastClicked: index });
      }
      if (this.props.schemaKey === "range_report") {
        selectedVehicleIds = this.state.rangeVehicles;
        if (!this.rangeClickedItem.includes(index))
          this.rangeClickedItem.push(index);
        this.setState({ rangeLastClicked: index });
      }
      if(this.props.schemaKey === "battery_trip_report"){
        selectedVehicleIds = this.state.batteryVehicles;
        if (!this.batteryClickedItem.includes(index))
          this.batteryClickedItem.push(index);
        this.setState({ batteryLastClicked: index });
      }
      if (this.props.schemaKey === "subscription_report") {
        if (!this.subscriptionClickedItem.includes(index))
          this.subscriptionClickedItem.push(index);
      }
      if (this.props.schemaKey === "summary_report") {
        selectedVehicleIds = this.state.summaryVehicles;
        if (!this.summaryClickedItem.includes(index))
          this.summaryClickedItem.push(index);
        this.setState({ summaryLastClicked: index });
      }
      let starttime = this.props.selectedVehicleId.starttime;
      let endtime = this.props.selectedVehicleId.endtime;
      // if(this.refs.search.value){
      //     this.refs.search.value = null
      // }
      this.setState({
        clickedItems: this.clickedItem,
        starttime: starttime,
        endtime: endtime,
        tripClickedItems: this.tripClickedItem,
        newTripClickedItem: this.newTripClickedItem,
        dailyClickedItems: this.dailyClickedItem,
        canDailyClickedItems: this.canDailyClickedItem,
        exideBatteryClickedItems: this.exideBatteryClickedItem,
        rangeClickedItems: this.rangeClickedItem,
        summaryClickedItems: this.summaryClickedItem,
        mileageClickedItems: this.mileageClickedItem,
        batteryClickedItems: this.batteryClickedItem,
        subscriptionClickedItems: this.subscriptionClickedItem,
      });
      const preProcessData = (respObj) => {
        let oldrespObj = {};
        for (let idx in respObj) {
          let item = respObj[idx];
          if (!(item.vehicleid in oldrespObj)) {
            oldrespObj[item.vehicleid] = [];
          }
          oldrespObj[item.vehicleid].push(item);
        }
        return oldrespObj;
      };
      const handleSuccess = (resp) => {
        if (this.props.schemaKey === "trip_report") {
          let oldrespObj = preProcessData(resp);

          tripProcessData(oldrespObj, window.vehicleMap, (data) => {
            this.data = data;
            this.tripData[index + 1] = data;
            this.setData(data);
            this.setState(
              {
                // body : data,
                reportData: this.tripData,
                busy: false,
                currentPage: data,
              },
              () => {
                if (this.refs.search.value) {
                  setTimeout(() => {
                    this.searchInputChanged();
                  }, 1000);
                }
              }
            );
            this.saveState(data, this.props.schemaKey, this.props.data);
          });
        }
        if (this.props.schemaKey === "mileage_report") {
          let oldrespObj = preProcessData(resp);
       
          mileageProcessData(oldrespObj, window.vehicleMap, (data) => {
            this.data = data;
            this.mileageData[index + 1] = data;
            this.setData(data);
            this.setState(
              {
                body : data,
                reportData: this.mileageData,
                busy: false,
                currentPage: data,
              },
              () => {
                if (this.refs.search.value) {
                  setTimeout(() => {
                    this.searchInputChanged();
                  }, 1000);
                }
              }
            );
            this.saveState(data, this.props.schemaKey, this.props.data);
          });
        }

        if (this.props.schemaKey === "new_trip_report") {
          let oldrespObj = preProcessData(resp);

          newTripProcessData(
            oldrespObj,
            window.vehicleMap,
            (data, from, to) => {
              if (from !== undefined && to !== undefined) {
                if (from) this.setState({ locFrom: true });
                if (to) this.setState({ locTo: true });
              }
              this.data = data;
              this.tripDataNew[index + 1] = data;
              //  this.setData(data)
              this.setState(
                {
                  body: data,
                  reportData: this.tripDataNew,
                  // busy : false,
                  currentPage: data,
                },
                () => {
                  if (this.refs.search.value) {
                    setTimeout(() => {
                      this.searchInputChanged();
                    }, 1000);
                  }
                  if (this.state.locFrom && this.state.locTo) {
                    this.setState({ busy: false });
                    this.setData(data);
                  }
                }
              );
              this.saveState(data, this.props.schemaKey, this.props.data);
            }
          );
        }
        if (this.props.schemaKey === "daily_report") {
          dailyProcessData(resp, window.vehicleMap, (data) => {
            this.data = data;
            this.dailyData[index + 1] = data;
            this.setData(data);
            this.setState(
              {
                body: data,
                reportData: this.dailyData,
                busy: false,
              },
              () => {
                if (this.refs.search.value) {
                  setTimeout(() => {
                    this.searchInputChanged();
                  }, 1000);
                }
              }
            );
            this.saveState(data, this.props.schemaKey, this.props.data);
          });
        }
        if (this.props.schemaKey === "can_daily_report") {
          dailyProcessData(resp, window.vehicleMap, (data) => {
            this.data = data;
            this.canDailyData[index + 1] = data;
            this.setData(data);
            this.setState(
              {
                body: data,
                reportData: this.canDailyData,
                busy: false,
              },
              () => {
                if (this.refs.search.value) {
                  setTimeout(() => {
                    this.searchInputChanged();
                  }, 1000);
                }
              }
            );
            this.saveState(data, this.props.schemaKey, this.props.data);
          });
        }
        if (this.props.schemaKey === "exide_battery_report") {
          exideBatteryProcessData(resp, window.vehicleMap, (data) => {
            this.data = data;
            this.exideBatteryData[index + 1] = data;
            this.setData(data);
            this.setState(
              {
                body: data,
                reportData: this.exideBatteryData,
                busy: false,
              },
              () => {
                if (this.refs.search.value) {
                  setTimeout(() => {
                    this.searchInputChanged();
                  }, 1000);
                }
              }
            );
            this.saveState(data, this.props.schemaKey, this.props.data);
          });
        }
        if (this.props.schemaKey === "battery_trip_report") {
          batteryProcessData(resp, window.vehicleMap, (data) => {
            this.data = data;
            this.batteryData[index + 1] = data;
            this.setData(data);
            this.setState(
              {
                body: data,
                reportData: this.batteryData,
                busy: false,
              },
              () => {
                if (this.refs.search.value) {
                  setTimeout(() => {
                    this.searchInputChanged();
                  }, 1000);
                }
              }
            );
            this.saveState(data, this.props.schemaKey, this.props.data);
          });
        }
        if (this.props.schemaKey === "subscription_report") {
          subscriptionProcessData(resp, (data) => {
            this.data = data;
            this.subscriptionData[index + 1] = data;
            this.setData(data);
            this.setState({
              body: data,
              reportData: this.subscriptionData,
              busy: false,
            });
            this.saveState(data, this.props.schemaKey, this.props.data);
          });
        }

        if (this.props.schemaKey === "range_report") {
          rangeProcessData(resp, window.vehicleMap, (data) => {
            this.data = data;
            this.rangeData[index + 1] = data;
            this.setData(data);
            this.setState(
              {
                body: data,
                reportData: this.rangeData,
                busy: false,
              },
              () => {
                if (this.refs.search.value) {
                  setTimeout(() => {
                    this.searchInputChanged();
                  }, 1000);
                }
              }
            );
            this.saveState(data, this.props.schemaKey, this.props.data);
          });
        }
        if (this.props.schemaKey === "summary_report") {
          summaryProcessData(resp, window.vehicleMap, (data) => {
            this.data = data;
            this.summaryData[index + 1] = data;
            this.setData(data);
            this.setState(
              {
                body: data,
                reportData: this.summaryData,
                busy: false,
              },
              () => {
                if (this.refs.search.value) {
                  setTimeout(() => {
                    this.searchInputChanged();
                  }, 1000);
                }
              }
            );
            this.saveState(data, this.props.schemaKey, this.props.data);
          });
        }
      };
      if (reportKeys.includes(this.props.schemaKey)) {
        if (this.props.schemaKey === "trip_report") {
          if (index + 1 in this.tripData) {
            this.setState(
              {
                // body : this.tripData[index+1],
                // busy :false,
                currentPage: this.tripData[index + 1],
              },
              () => {
                setTimeout(() => {
                  this.setState({
                    body: this.tripData[index + 1],
                    items: this.tripData[index + 1].slice(0, 50),
                  });
                }, 100);
                filterAndSetData();
                setTimeout(() => {
                  if (this.refs.search.value) {
                    this.searchInputChanged;
                  }
                });
              }
            );
          } else {
            let body = {
              starttime: starttime,
              endtime: endtime,
              vehicleid: selectedVehicleIds[index],
            };
            ReportAPIs.getPrecomputeTrips(body).then(handleSuccess, (r) => {
              if (r) window.responseError = "Data Fetching Failed";
              handleSuccess({});
            });
          }
        }
        if (this.props.schemaKey === "mileage_report") {
          if (index + 1 in this.mileageData) {
            this.setState(
              {
                // body : this.tripData[index+1],
                // busy :false,
                currentPage: this.mileageData[index + 1],
              },
              () => {
                setTimeout(() => {
                  this.setState({
                    body: this.mileageData[index + 1],
                    items: this.mileageData[index + 1].slice(0, 50),
                  });
                }, 100);
                filterAndSetData1();
                setTimeout(() => {
                  if (this.refs.search.value) {
                    this.searchInputChanged;
                  }
                });
              }
            );
          } else {
            let body = {
              starttime: starttime,
              endtime: endtime,
              vehicleid: selectedVehicleIds[index],
            };
            ReportAPIs.getPrecomputeTrips(body).then(handleSuccess, (r) => {
              if (r) window.responseError = "Data Fetching Failed";
              handleSuccess({});
            });
          }
        }
        if (this.props.schemaKey === "new_trip_report") {
          if (index + 1 in this.tripDataNew) {
            this.setState(
              {
                currentPage: this.tripDataNew[index + 1],
                // body:this.tripDataNew[index+1]
              },
              () => {
                setTimeout(() => {
                  this.setState({
                    busy: false,
                    body: this.tripDataNew[index + 1],
                    items: this.tripDataNew[index + 1].slice(0, 50),
                  });
                }, 100);
              }
            );
          } else {
            let body = {
              starttime: starttime,
              endtime: endtime,
              vehicleno: selectedVehicleIds[index],
            };
            ReportAPIs.newPrecomputeTrips(body).then(handleSuccess, (r) => {
              if (r) window.responseError = "Data Fetching Failed";
              handleSuccess({});
            });
          }
        }
        if (this.props.schemaKey === "daily_report") {
          if (index + 1 in this.dailyData) {
            this.setState(
              {
                body: this.dailyData[index + 1],
                // busy :false
              },
              () => {
                setTimeout(() => {
                  this.setState({
                    busy: false,
                    items: this.dailyData[index + 1].slice(0, 50),
                  });
                }, 100);
                if (this.refs.search.value) {
                  setTimeout(() => {
                    this.searchInputChanged();
                  }, 1000);
                }
              }
            );
          } else {
            let body = {
              starttime: starttime,
              endtime: endtime,
              vehicleid: selectedVehicleIds[index],
              tzoffset: momentTZ().utcOffset() * 60,
            };
            ReportAPIs.getPrecomputeDailytrips(body).then(
              handleSuccess,
              (r) => {
                if (r) window.responseError = "Data Fetching Failed";
                handleSuccess({});
              }
            );
          }
        }
        if (this.props.schemaKey === "can_daily_report") {
          if (index + 1 in this.canDailyData) {
            this.setState(
              {
                body: this.canDailyData[index + 1],
                // busy :false
              },
              () => {
                setTimeout(() => {
                  this.setState({
                    busy: false,
                    items: this.canDailyData[index + 1].slice(0, 50),
                  });
                }, 100);
                if (this.refs.search.value) {
                  setTimeout(() => {
                    this.searchInputChanged();
                  }, 1000);
                }
              }
            );
          } else {
            let body = {
              starttime: starttime,
              endtime: endtime,
              vehicleid: selectedVehicleIds[index],
              tzoffset: momentTZ().utcOffset() * 60,
            };
            ReportAPIs.getPrecomputeDailytrips(body).then(
              handleSuccess,
              (r) => {
                if (r) window.responseError = "Data Fetching Failed";
                handleSuccess({});
              }
            );
          }
        }
        if (this.props.schemaKey === "exide_battery_report") {
          if (index + 1 in this.exideBatteryData) {
            this.setState(
              {
                body: this.exideBatteryData[index + 1],
              },
              () => {
                setTimeout(() => {
                  this.setState({
                    busy: false,
                    items: this.exideBatteryData[index + 1].slice(0, 50),
                  });
                }, 100);
                if (this.refs.search.value) {
                  setTimeout(() => {
                    this.searchInputChanged();
                  }, 1000);
                }
              }
            );
          } else {
            let auth = window.getAuth();
            let body = {
              starttime: starttime,
              endtime: endtime,
              vehicleid: selectedVehicleIds[index],
              token: auth.token,
            };
            ReportAPIs.getExideBatteryDailyReport(body).then(
              handleSuccess,
              (r) => {
                if (r) window.responseError = "Data Fetching Failed";
                handleSuccess([]);
              }
            );
          }
        }
        if (this.props.schemaKey === "battery_trip_report") {
          if (index + 1 in this.batteryData) {
            this.setState(
              {
                body: this.batteryData[index + 1],
                busy: false,
              },
              () => {
                setTimeout(() => {
                  this.setState({
                    busy: false,
                    items: this.batteryData[index + 1].slice(0, 50),
                  });
                }, 100);
                if (this.refs.search.value) {
                  setTimeout(() => {
                    this.searchInputChanged();
                  }, 1000);
                }
              }
            );
          } else {
            let body = {
              starttime: starttime,
              endtime: endtime,
              vehicleid: selectedVehicleIds[index],
              tzoffset: momentTZ().utcOffset() * 60,
            };
            ReportAPIs.getClnBatteryTripReport(body).then(
              handleSuccess,
              (r) => {
                if (r) window.responseError = "Data Fetching Failed";
                handleSuccess({});
              }
            );
          }
        }
        if (this.props.schemaKey === "subscription_report") {
          if (index + 1 in this.subscriptionData) {
            const data = this.subscriptionData[index + 1];
            this.setData(data);
            this.setState({
              body: data,
              items: data.slice(0, 50),
              busy: false,
            });
          } else {
            ReportAPIs.getClnSubscriptionReport({
              limit: 100,
              offset: index * 100,
            }).then(handleSuccess, () => handleSuccess([]));
          }
        }
        if (this.props.schemaKey === "range_report") {
          if (index + 1 in this.rangeData) {
            this.setState(
              {
                body: this.rangeData[index + 1],
                busy: false,
              },
              () => {
                setTimeout(() => {
                  this.setState({
                    busy: false,
                    items: this.rangeData[index + 1].slice(0, 50),
                  });
                }, 100);
                if (this.refs.search.value) {
                  setTimeout(() => {
                    this.searchInputChanged();
                  }, 1000);
                }
              }
            );
          } else {
            let body = {
              starttime: starttime,
              endtime: endtime,
              vehicleid: selectedVehicleIds[index],
              tzoffset: momentTZ().utcOffset() * 60,
            };
            ReportAPIs.getPrecomputeDailytrips(body).then(
              handleSuccess,
              (r) => {
                if (r) window.responseError = "Data Fetching Failed";
                handleSuccess({});
              }
            );
          }
        }
        if (this.props.schemaKey === "summary_report") {
          if (index + 1 in this.summaryData) {
            this.setState(
              {
                body: this.summaryData[index + 1],
                // busy :false
              },
              () => {
                setTimeout(() => {
                  this.setState({
                    busy: false,
                    items: this.summaryData[index + 1].slice(0, 50),
                  });
                }, 100);
                if (this.refs.search.value) {
                  setTimeout(() => {
                    this.searchInputChanged();
                  }, 1000);
                }
              }
            );
          } else {
            let body = {
              starttime: starttime,
              endtime: endtime,
              vehicleid: selectedVehicleIds[index],
            };
            ReportAPIs.getPrecomputeSummarytrips(body).then(
              handleSuccess,
              (r) => {
                if (r) window.responseError = "Data Fetching Failed";
                handleSuccess({});
              }
            );
          }
        }
      }
    }
  }

  toggleSort(sortObj, processed = false) {
    let headkey = ["tDuration","duration"]
    if (!this.mounted || !sortObj) return;
    if(headkey.includes(sortObj.key)) return
    clearTimeout(this.toggleSortDebounce);
    this.toggleSortDebounce = setTimeout(() => {
      if (!("ascOrder" in sortObj)) {
        sortObj.ascOrder = true;
      }
      if (
        !processed &&
        this.state.sortBy &&
        this.state.sortBy.key === sortObj.key
      ) {
        sortObj.ascOrder = !sortObj.ascOrder;
      }
      let data = []
      if(this.reportKeysData.includes(this.props.schemaKey)) {
        data = [...this.state.items]
      }else {
        data = [...this.state.body];
      }
      let action = sortObj.ascOrder ? -1 : 1;

      if (sortObj.timestamp) {
        data = data.sort(function (a, b) {
          return (b[sortObj.timestamp] - a[sortObj.timestamp]) * action;
        });
      } else if (data[0]) {
        switch (typeof data[0][sortObj.key]) {
          case "string":
            data = data.sort(function (a, b) {
              if (a[sortObj.key] < b[sortObj.key]) return -1 * action;
              if (a[sortObj.key] > b[sortObj.key]) return 1 * action;
              return 0;
            });
            break;
          default:
            data = data.sort(function (a, b) {
              return (b[sortObj.key] - a[sortObj.key]) * action;
            });
            break;
        }
      }
      if(this.reportKeysData.includes(this.props.schemaKey)) {
        this.setState({
          sortBy: sortObj,
          items: data,
        });
      }else {
        this.setState({
          sortBy: sortObj,
          body: data,
        });
      }
    }, 500);
  }

  getSortIcon(item) {
    let headkey = ['tDuration','duration']
    if (!headkey.includes(item.key) && this.state.sortBy && item.key === this.state.sortBy.key) {
      if (this.state.sortBy.ascOrder) {
        return <i className="fa fa-sort-amount-asc"></i>;
      } else {
        return <i className="fa fa-sort-amount-desc"></i>;
      }
    }
  }
  containsObject(obj, list) {
    var i;
    for (i = 0; i < list.length; i++) {
      if (list[i] === obj) {
        return true;
      }
    }
    return false;
  }

  searchInputChanged() {
    if (!this.mounted) return;
    if (this.props.schemaKey === "trip_report") {
      if (this.tripData[1]) {
        this.reportData = [];
        this.reportData = this.tripData;
        this.setState({
          tripLastClicked: 0,
        });
      }
    }
    if (this.props.schemaKey === "mileage_report") {
      if (this.mileageData[1]) {
        this.reportData = [];
        this.reportData = this.mileageData;
        this.setState({
          mileageLastClicked: 0,
        });
      }
    }
    if (this.props.schemaKey === "new_trip_report") {
      if (this.tripDataNew[1]) {
        this.reportData = [];
        this.reportData = this.tripDataNew;
        this.setState({
          newTripLastClicked: 0,
        });
      }
    }
    if (this.props.schemaKey === "daily_report") {
      if (this.dailyData[1]) {
        this.reportData = this.dailyData;
        this.setState({
          dailyLastClicked: 0,
        });
      }
    }
    if (this.props.schemaKey === "can_daily_report") {
      if (this.canDailyData[1]) {
        this.reportData = this.canDailyData;
        this.setState({
          canDailyLastClicked: 0,
        });
      }
    }
    if (this.props.schemaKey === "exide_battery_report") {
      if (this.exideBatteryData[1]) {
        this.reportData = this.exideBatteryData;
        this.setState({
          exideBatteryLastClicked: 0,
        });
      }
    }
    if (this.props.schemaKey === "battery_trip_report") {
      if (this.batteryData[1]) {
        this.reportData = this.batteryData;
        this.setState({
          batteryLastClicked: 0,
        });
      }
    }
    if (this.props.schemaKey === "range_report") {
      if (this.rangeData[1]) {
        this.reportData = this.rangeData;
        this.setState({
          canDailyLastClicked: 0,
        });
      }
    }
    if (this.props.schemaKey === "summary_report") {
      if (this.summaryData[1]) {
        this.reportData = this.summaryData;
        this.setState({
          summaryLastClicked: 0,
        });
      }
    }
    let items = this.state.clickedItems;
    for (let idx in this.reportData) {
      let data = this.reportData[idx];
      for (let rdx in data) {
        let rawAvailable = this.containsObject(data[rdx], this.sortedReport);
        if (rawAvailable) {
          continue;
        }
        this.sortedReport.push(data[rdx]);
      }
    }
    let str = this.refs.search.value
      ? this.refs.search.value.trim().toLowerCase()
      : "";
    // let str = ""
    let sortedData = this.sortedReport.filter((item) => {
      for (let idx in item) {
        if ((item[idx] + "").trim().toLowerCase().indexOf(str) !== -1) {
          return true;
        }
      }
      return false;
    });
    this.setState(
      {
        searchInput: this.refs.search.value,
        body: this.sortedReport.filter((item) => {
          for (let idx in item) {
            if ((item[idx] + "").trim().toLowerCase().indexOf(str) !== -1) {
              return true;
            }
          }
          return false;
        }),
        index: 0,
        items: sortedData,
      },
      () => {
        if (!this.refs.search.value) {
          this.changePage(this.state.index);
        }
      }
    );
  }
  searchClicked() {}

  getHead() {
    let user = window.auth.userinfo.username;
    let disableHeadEV = [
      "cpk",
      "mileage",
      "fuelprice",
      "idlingtime",
      "acidlingtime",
    ];
    let disableHeadNonEV = ["status"];
    let disableHead = [
      "cpk",
      "mileage",
      "fuelprice",
      "idlingtime",
      "acidlingtime",
    ];
    let pblDisable = ["mileage", "cpk"];
    let pblHead = ["ophours", "consumption", "cph"];
    let evHead = ["startdte", "enddte"];
    let greenFuelDisable = ["cpk", "startfl", "endfl", "fuelused", "fuelprice"];
    let head = (this.props.data.head ? this.props.data.head : []).filter(
      (h) => {
        if (this.pblReport === "SHOW") {
          for (let idx in pblDisable) {
            if (pblDisable[idx] === h.key) return false;
          }
        }
        if (user === "greenfuel.admin") {
          for (let idx in greenFuelDisable) {
            if (greenFuelDisable[idx] === h.key) return false;
          }
        }
        if (user !== "greenfuel.admin") {
          if (h.key === "chargingtime") return false;
        }
        if (this.pblReport == undefined || this.pblReport !== "SHOW") {
          for (let idx in pblHead) {
            if (pblHead[idx] === h.key) return false;
          }
        }
        if (this.evOnly === "DISABLE") {
          // console.log("inside disable");
          for (let idx in disableHead) {
            if (disableHead[idx] === h.key) {
              return false;
            }
          }
        }
        if (this.evOnly === "SHOW") {
          for (let idx in evHead) {
            if (evHead[idx] === h.key) {
              return true;
            }
            if (h.key === "startdte" || h.key === "enddte") return false;
          }
        }
        if (this.evOnly == undefined) {
          for (let idx in evHead) {
            if (evHead[idx] === h.key) {
              return false;
            }
          }
        }

        if (this.evConfig === true) {
          for (let idx in disableHeadEV) {
            if (disableHeadEV[idx] === h.key) {
              return false;
            }
          }
        }

        if (this.evConfig != true || this.evConfig == undefined) {
          for (let idx in disableHeadNonEV) {
            if (disableHeadNonEV[idx] === h.key) {
              return false;
            }
          }
        }

        if ("isShowable" in h) {
          return h.isShowable(this.vehicle, this.props, h);
        }
        return true;
      }
    );
    let totalWidth = 0;

    for (let idx in head) {
      if (head[idx].width) {
        totalWidth += head[idx].width;
      } else {
        totalWidth++;
      }
    }

    for (let idx in head) {
      if (head[idx].width) {
        head[idx].widthVal = (head[idx].width / totalWidth) * 100;
      }
    }
    return head;
  }

  getData(name = false) {
    return this.state.filtered.map((item) => {
      let head = this.getHead();
      let tempItem = {};
      for (let idx in head) {
        tempItem[name ? head[idx].name : head[idx].key] = this.getBodyData(
          item[head[idx].processedKey || head[idx].key]
        );
      }
      return tempItem;
    });
  }

  saveState(prevProps) {
    if (!prevProps.saveState) return;

    prevProps.saveState(this.state, prevProps.schemaKey, this.props.data);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.schemaKey !== this.props.schemaKey) {
      this.setState({ filtered: [], items: [] });
    }
    this.saveState(prevProps);
  }

  componentWillUnmount() {
    this.scrollRef.removeEventListener("scroll", this.handleScroll);
    this.mounted = false;
    this.saveState(this.props);
  }
  handleScroll = () => {
    if (this.reportKeysData.includes(this.props.schemaKey) && this.scrollRef) {
      const { scrollTop, scrollHeight, clientHeight } = this.scrollRef;
      if (scrollTop + clientHeight >= scrollHeight - 5) {
        if (this.state.items.length) this.loadMore();
      }
    }
  };
  loadMore = () => {
    const { startIndex } = this.state;
    const data = this.state.body;
    let endIndex = startIndex + 50;
    if (endIndex > data.length) endIndex = data.length;
    const newItems = data.slice(startIndex, endIndex);

    this.setState(
      (prevState) => ({
        items: [...prevState.items, ...newItems],
        startIndex: prevState.startIndex + 50,
        hasMore: startIndex + 50 < data.length,
      }),
      () => {}
    );
  };

  onItemClick = (selectedItem) => {
    if (this.props.data.onItemClick) {
      this.setState({ selectedItem });
      this.props.data.onItemClick(selectedItem);
    }
  };

  isItemSelected = (item) =>
    this.state.selectedItem ? this.state.selectedItem.uid === item.uid : false;

  closeDatePopup() {
    this.setState({ datePopup: false });
  }

  render() {
    return (
      <div className="InTable -white">
        {/* {this.state.datePopup ?(<div className='it-date'>
                    <span className='itd-fromTo'>Data showing from  <span className='itdf-fromTo'>{this.state.startDate}</span>  to  <span className='itdf-fromTo'> {this.state.endDate}</span> </span><div className='itd-close' onClick={()=>this.closeDatePopup()}>x</div>
                </div> ): null} */}
        <CallbackBuddy
          if={this.props.schemaKey}
          onDataChange={this.onDataChange}
        />
        {this.state.busy ? (
          <div className="it-spinner"></div>
        ) : this.state.body.length === 0 ? (
          <div
            className={
              "it-no-data" + (this.props.data.smallFont ? " -smallFont" : "")
            }
          >
            {this.props.data.noDataMsg || "No Data"}
          </div>
        ) : null}
        {/* {
                   !window.dataForAll ? (
                    <div className={"it-disable"}>
                        {window.graphDataErr}
                    </div>
                  ) : null
                } */}
        {this.props.data.showName ? (
          <div className="it-head">{this.props.data.name}</div>
        ) : (
          ""
        )}
        <table className={this.props.data.showName ? "showName" : ""}>
          <thead>
            <tr>
              {this.getHead().map((head, index) => {
                return (
                  <th
                    onClick={() => {
                      this.props.schemaKey !== "can_data_report"
                        ? this.toggleSort(head)
                        : this.props.schemaKey === "can_data_report" &&
                          (head.key === "time" || head.key === "parameter")
                        ? this.toggleSort(head)
                        : null;
                    }}
                    style={{
                      width: head.widthVal ? head.widthVal + "%" : null,
                    }}
                    key={index}
                  >
                    {this.getSortIcon(head)}
                    {head.name}
                  </th>
                );
              })}
            </tr>
          </thead>
          <tbody
            ref={(ref) => (this.scrollRef = ref)}
            style={{ height: this.getMaxHeight() }}
          >
            {this.getBody(
              this.state.body,
              this.state.index,
              this.state.limit
            ).map((item, index) => {
              return (
                <tr
                  key={index}
                  className={
                    (this.props.data.onItemClick ? "selectable" : "") +
                    (this.isItemSelected(item) ? " -active" : "")
                  }
                  onClick={() => {
                    this.onItemClick(item);
                  }}
                >
                  {this.getHead().map((head, index2) => {
                    let styles = {
                      width: head.widthVal ? head.widthVal + "%" : null,
                    };
                    if (head.color) styles.color = head.color(item);
                    return (
                      <td
                        style={styles}
                        className={head.onClick ? "-clickable" : ""}
                        onClick={() => {
                          head.onClick
                            ? head.onClick(
                                item[head.processedKey || head.key],
                                item
                              )
                            : "";
                        }}
                        key={index2}
                      >
                        {this.getBodyData(
                          item[head.processedKey ? head.processedKey : head.key]
                        )}
                        {head.getIcon ? (
                          <div className="inTable_iconWrapper">
                            <i
                              className={
                                "fa " +
                                head.getIcon(
                                  item[head.processedKey || head.key],
                                  item,
                                  head
                                )
                              }
                            ></i>
                          </div>
                        ) : (
                          ""
                        )}
                      </td>
                    );
                  })}
                </tr>
              );
            })}
          </tbody>
        </table>
        {
        this.props && this.props.schemaKey !== "can_data_report" || this.props && this.props.schemaKey !== "jem_can_data_report" || this.props && this.props.schemaKey !== "bg_can_data_report"? (
          <div className="it-pagination">
            <input
              placeholder="Search"
              ref="search"
              onChange={this.searchInputChanged}
            />
            {this.getPagination().map((item, index) => {
              return (
                <div className="itp-item" key={index}>
                  <div
                    className={Dom.Class(
                      {
                        active: item === this.state.index,
                        "itpi-name-tripClicked":
                          this.props.schemaKey === "trip_report" &&
                          this.state.tripClickedItems.includes(item),
                        "itpi-name-mileageClicked":
                          this.props.schemaKey === "mileage_report" &&
                          this.state.mileageClickedItems.includes(item),
                        "itpi-name-tripClickedNew":
                          this.props.schemaKey === "new_trip_report" &&
                          this.state.newTripClickedItem.includes(item),
                        "itpi-name-dailyClicked":
                          (this.props.schemaKey === "daily_report" &&
                            this.state.dailyClickedItems.includes(item)) ||
                          (this.props.schemaKey === "exide_battery_report" &&
                            this.state.exideBatteryClickedItems.includes(item)),
                        "itpi-name-candailyClicked":
                          this.props.schemaKey === "can_daily_report" &&
                          this.state.canDailyClickedItems.includes(item),
                        "itpi-name-rangeClicked":
                          this.props.schemaKey === "range_report" &&
                          this.state.rangeClickedItems.includes(item),
                        "itpi-name-summaryClicked":
                          this.props.schemaKey === "summary_report" &&
                          this.state.summaryClickedItems.includes(item),
                        "itpi-name-subscriptionClicked":
                          this.props.schemaKey === "subscription_report" &&
                          this.state.subscriptionClickedItems.includes(item),
                      },
                      "itpi-name"
                    )}
                    onClick={() => this.changePage(item)}
                  >
                    {item + 1}
                  </div>
                </div>
              );
            })}
          </div>
        ) : (
          ""
        )}
      </div>
    );
  }
}

export default InTable;
